import { render, staticRenderFns } from "./FreeCustomers.vue?vue&type=template&id=4ade6f4c"
import script from "./FreeCustomers.vue?vue&type=script&lang=js"
export * from "./FreeCustomers.vue?vue&type=script&lang=js"
import style0 from "./FreeCustomers.vue?vue&type=style&index=0&id=4ade6f4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports